import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './style.module.css';
import { CSSTransition } from 'react-transition-group';
import HealthHeader from '../../../Components/HealthHeader/index.js';
import Profile from './Profile/index.js';
import HistoryCard from './HistoryCard/index.js';
import DetailsCard from './DetailsCard/index.js';
import LeftIcon from './leftIcon.svg';
import DetailsCardTreatment from './DetailsCardTreatment/index.js';
import BotHistoryCard from './BotHistoryCard/index.js';
import NovoTratamentoModal from './NovoTratamentoModal.js';
import { usePatient } from '../../../Contexts/PatientContext';

import SurgeryDetailsCard from './SurgeryDetailsCard/index.js';

const ProductInternal = () => {
  const { patientData, refreshPatientData } = usePatient();
  const [showNovoTratamentoModal, setShowNovoTratamentoModal] = useState(false);
  const [treatmentKey, setTreatmentKey] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const isEffectsProduct = patientData?.type === 'efeitos-adversos';
  const isCirurgiasProduct = patientData?.type === 'cirurgias';

  useEffect(() => {
    setTreatmentKey(prev => prev + 1);
  }, [patientData?.treatments?.length]);

  const handleModalClose = () => {
    setShowNovoTratamentoModal(false);
    setTreatmentKey(prev => prev + 1);
  };

  const handleTreatmentAdded = async () => {
    try {
      setIsRefreshing(true);
      await refreshPatientData();
      setTreatmentKey(prev => prev + 1);
    } catch (error) {
      console.error('ProductInternal - Erro ao atualizar dados do paciente:', error);
      setTreatmentKey(prev => prev + 1);
    } finally {
      setIsRefreshing(false);
      setShowNovoTratamentoModal(false);
    }
  };

  return (
    <div className={styles.container}>
      <CSSTransition
        in={true}
        classNames="anim"
        timeout={500}
        appear={false}
        unmountOnExit={false}
      >
        <div>
          <section>
            <div className={styles.top}>
              <HealthHeader title="Perfil de Pacientes" />
            </div>     

            <div className={styles.topCardsContainerTop}>
              <Profile 
                onAddTreatment={isEffectsProduct ? () => setShowNovoTratamentoModal(true) : undefined}
              />
              <HistoryCard />            
            </div>
          </section>

          <section className={styles.cardContainer}>
            <div className={styles.subtitle}>
              <h3> {isCirurgiasProduct ? 'Dados da Cirurgia' : 'Características da Doença'} </h3>
              <img src={LeftIcon} alt="Kollecta Health"/>
            </div>
            {isCirurgiasProduct ? <SurgeryDetailsCard /> : <DetailsCard />}
          </section>

          {!isCirurgiasProduct && (
            <>
              <section className={styles.cardContainer}>
                <div className={styles.subtitle}>
                  <h3> Terapia medicamentosa  </h3>
                  <img src={LeftIcon} alt="Kollecta Health"/>
                </div>
                <DetailsCardTreatment key={`${treatmentKey}-medications`} type="medications" />
              </section>

              <section className={styles.cardContainer}>
                <div className={styles.subtitle}>
                  <h3> Terapia não medicamentosa  </h3>
                  <img src={LeftIcon} alt="Kollecta Health"/>
                </div>
                <DetailsCardTreatment key={`${treatmentKey}-non-medications`} />
              </section>
            </>
          )}

          <section className={styles.cardContainer}>
            <div className={styles.subtitle}>
              <h3> Histórico de Mensagens  </h3>
              <img src={LeftIcon} alt="Kollecta Health"/>
            </div>
            <BotHistoryCard />
          </section>

          {isEffectsProduct && (
            <NovoTratamentoModal 
              visible={showNovoTratamentoModal}
              onClose={handleModalClose}
              onTreatmentAdded={handleTreatmentAdded}
            />
          )}
        </div>
      </CSSTransition>
    </div>
  );
};

export default ProductInternal;
